/* eslint-disable max-lines */
import React, { useContext, useState } from 'react';
import { Card, makeStyles } from '@material-ui/core';
import { getFullDate, getTime } from '../../utils/dateTimeUtil';
import { useSelector, useDispatch } from 'react-redux';
import { selectTheReport } from '../../redux/Reports/ReportsAction';
import RadiologyDialog from './Dialogs/RadiologyDialog';
import { PropTypes } from 'prop-types';

import MessagesContext from '../../contexts/messagesContext';
import LanguageContext from '../../contexts/languageContext';
import { Options } from '../UI';
import useCheckMobileScreen from '../../hooks/useWidth';
import { useHistory, useParams } from 'react-router';

const styles = makeStyles((theme) => ({
    cardContainer: {
        paddingBottom: '0px !important',
        position: 'relative',
        margin: '15px auto ',
        direction: 'rtl'
    },
    root: {
        // [theme.breakpoints.only('lg')]: {
        //     maxWidth: '91% !important'
        // },
        // [theme.breakpoints.only('md')]: {
        //     maxWidth: '91% !important'
        // },
        [theme.breakpoints.down('sm')]: {
            maxWidth: '100%'
        },
        boxShadow: '0 2px 8px 0 rgba(84, 94, 102, 0.12)',
        paddingBottom: '0px !important',
        overflow: 'hidden',
        margin: 'auto',
        borderRadius: '4px',
        border: 'solid 1.5px rgba(0, 126, 153, 0.1)',
        display: 'block',
        backgroundColor: '#ffffff',
        padding: ' 10px 15px 7px',
        minHeight: '78px',
        // pointerEvents: 'auto',
        [theme.breakpoints.down(1025)]: {
            boxShadow: 'unset',
            border: 'unset'
        }
    },
    activeCard: {
        backgroundColor: '#f6fbff',
        border: 'solid 1.5px #1b90fa !important'
    },
    firstRowCardContent: {
        display: 'flex',
        flexDirection: 'row'
    },
    dateContent: {
        fontWeight: '10px',
        display: 'flex',
        paddingBottom: '2px',
        justifyContent: 'flex-start'
    },
    secondRowCardContent: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end'
    },
    thirdRowCardContent: {},
    optionIconContainer: {
        position: 'relative'
    },
    moreOptionIcon: {
        cursor: 'pointer'
    },
    card__menuItem: () => ({
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        width: '110px',
        fontFamily: 'inherit'
    }),
    card__more: {
        position: 'relative',
        height: '16px',
        display: 'inline-block',
        // margin: '10px',
        width: '80%',
        textAlign: 'right',
        right: '-10px',
        top: '-10px'
    },
    card__more__image: {
        boxSizing: 'content-box'
    },
    card__report__name__container: {
        // width: '60%',
        marginRight: 'auto',
        textAlign: 'left',
        pointerEvents: 'none !important'
    },
    card__date: {
        paddingRight: (card) => (getTime(card?.reported) === '00:00' ? '0px' : '20px'),
        fontSize: '13px',
        color: '#363636'
    },
    card__time: {
        fontSize: '13px',
        color: '#363636'
    },
    card__report__name: {
        fontSize: '14px',
        fontWeight: 'bold',
        color: '#363636',
        lineHeight: '17px',
        userSelect: 'none',
        pointerEvents: 'none !important'
    },
    card__report__name__active: {
        fontSize: '14px',
        fontWeight: 'bold',
        color: '#363636',
        lineHeight: '17px',
        userSelect: 'none',
        pointerEvents: 'none !important'
    },
    card__location__name: {
        paddingBottom: '3px',
        lineHeight: '1',
        fontSize: '14px',
        color: '#363636',
        userSelect: 'none'
    },
    card__location__name__active: {
        paddingBottom: '3px',
        lineHeight: '1',
        fontSize: '16px',
        color: '#363636',
        userSelect: 'none'
    },
    card__locations: {
        paddingTop: '10px'
    }
}));
const ReportCard = ({ card, notEditClinical }) => {
    const isMobile = useCheckMobileScreen();
    const params = useParams();
    const history = useHistory();
    const { messages } = useContext(MessagesContext);
    const { lang } = useContext(LanguageContext);
    const dispatch = useDispatch();
    const [dialogOpen, setDialogOpen] = useState(false);
    const [dialogMode, setDialogMode] = useState('');
    const reportId = useSelector((state) => state.reports?.form?.reportId);
    const classes = styles({ ...card, rtl: lang === 'fa' });
    const options = [
        { label: messages.edit, icon: 'edit', value: 0 },
        { label: messages.delete, icon: 'delete', value: 1 }
    ];
    const detailPath = `/${params.clinicId}/patient/${params?.id}/radiology/detail`;
    const formPath = `/${params.clinicId}/patient/${params?.id}/radiology/form`;
    const selectReportCard = (card) => {
        dispatch(selectTheReport(card));
    };

    const openDialog = (mode) => {
        setDialogMode(mode);
        setDialogOpen(true);
    };
    const handleClose = () => {
        setDialogOpen(false);
    };
    // const [cardHover, setCardHover] = useState(null);

    const handleSelectOptions = (option) => {
        // setCardHover(null);
        selectReportCard(card);
        if (option?.value === 0) {
            if (isMobile) {
                history.push(formPath);
            } else {
                openDialog('edit');
            }
        } else if (option?.value === 1) {
            openDialog('delete');
        }
    };

    return (
        <>
            <div className={`${classes.cardContainer}`}>
                <Card
                    className={`${card?.id === reportId && !isMobile ? classes.activeCard : ''} ${
                        classes.root
                    }`}
                >
                    <div
                        onClick={(event) => {
                            isMobile && history.push(detailPath);
                            selectReportCard(card, event);
                        }}
                        data-testid="reportCard"
                    >
                        <div className={classes.firstRowCardContent} color="textSecondary">
                            <div className={classes.card__more}>
                                {/* {(card.id === reportId || cardHover || isMobile) && ( */}
                                <Options
                                    className={card?.id === reportId ? '' : classes.hiddenOption}
                                    top={10}
                                    right={10}
                                    width={'24px'}
                                    options={options}
                                    // handleClose={() => setCardHover(null)}
                                    handleSelect={handleSelectOptions}
                                    disabled={notEditClinical}
                                />
                                {/* )} */}
                            </div>
                            {/* <a> */}
                            <div className={classes.card__report__name__container}>
                                <div className={classes.card__report__name}>
                                    {card?.report_type?.name}
                                </div>
                            </div>
                            {/* </a> */}
                        </div>
                        <div className={classes.secondRowCardContent}>
                            <div className={classes.card__locations} style={{ textAlign: 'left' }}>
                                {card?.locations.map((i) => (
                                    <div
                                        className={`${
                                            card.id === reportId && !isMobile
                                                ? classes.card__location__name__active
                                                : classes.card__location__name
                                        }`}
                                        key={i.id}
                                    >
                                        {i.name}
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className={classes.thirdRowCardContent}>
                            <div className={classes.dateContent}>
                                {getTime(card?.reported) !== '00:00' && (
                                    <div className={classes.card__time}>
                                        {getTime(card?.reported)}
                                    </div>
                                )}
                                <div className={classes.card__date}>
                                    {getFullDate(card?.reported)}
                                </div>
                            </div>
                        </div>
                    </div>
                </Card>
            </div>

            <RadiologyDialog
                dialogMode={dialogMode}
                openDialog={dialogOpen}
                handleClose={handleClose}
            />
        </>
    );
};

ReportCard.propTypes = {
    card: PropTypes.object,
    notEditClinical: PropTypes.bool
};
export default ReportCard;
